export default __webpack_public_path__ + "static/media/AO-logo.613f581d.png";